import I18n from 'I18n';
import { createAction } from 'redux-actions';
import getErrorMessageKeyFromErrorCode from './getErrorMessageKeyFromErrorCode';
const createErrorAction = (actionName, titleMessageKey, errorMessageKey) => createAction(actionName, error => error, error => ({
  notification: {
    type: 'danger',
    title: I18n.text(titleMessageKey),
    titleText: I18n.text(titleMessageKey),
    use: 'inline',
    message: errorMessageKey ? I18n.text(errorMessageKey) : I18n.text(getErrorMessageKeyFromErrorCode(error && error.xhr && error.xhr.status || 0))
  }
}));
export default createErrorAction;